import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    AlterarTipoRelacaoClienteController,
    ExcluirTipoRelacaoClienteController,
    InserirTipoRelacaoClienteController,
    ListarTipoRelacaoClienteController,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteControllers";
import { ITipoRelacaoCliente } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/TipoRelacaoCliente/TipoRelacaoClienteInterface";
import Table from "../../../../../Table";
import { Collapse } from "@material-ui/core";
import UnForm from "../../../../../Form";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import Swal from "sweetalert2";
import { Spinner } from "../../../../../Loding/SpinnerPadrao";
import { FormProvider, useForm } from "react-hook-form";

export default function TipoRelacaoCliente() {
    const [editingRow, setEditingRow] = useState<ITipoRelacaoCliente | null>(
        null
    );
    const [isCollapseOpen, setIsCollapseOpen] = useState(false);
    const [isAddCollapseOpen, setIsAddCollapseOpen] = useState(false);

    const formMethods = useForm();

    const { reset } = formMethods;

    const {
        value: lstTipoRelacaoCliente,
        loading: lstTipoRelacaoClienteLoading,
        execute: updateListaTipoRelacaoCliente,
    } = useAsyncEffect(() => ListarTipoRelacaoClienteController(), []);

    const {
        execute: AlterarTipoRelacaoCliente,
        loading: AlterarTipoRelacaoClienteLoading,
    } = useAsyncCallback(AlterarTipoRelacaoClienteController);

    const {
        execute: InserirTipoRelacaoCliente,
        loading: InserirTipoRelacaoClienteLoading,
    } = useAsyncCallback(InserirTipoRelacaoClienteController);

    const {
        execute: ExcluirTipoRelacaoCliente,
        loading: ExcluirTipoRelacaoClienteLoading,
    } = useAsyncCallback(ExcluirTipoRelacaoClienteController);

    async function handleSaveEdit(formData: ITipoRelacaoCliente) {
        if (editingRow && formData.DS_TIPO_RELACAO_CLIENTE) {
            await AlterarTipoRelacaoCliente({
                ...editingRow,
                DS_TIPO_RELACAO_CLIENTE: formData.DS_TIPO_RELACAO_CLIENTE,
            });
            setEditingRow(null);
            setIsCollapseOpen(false);
            updateListaTipoRelacaoCliente();
        }
    }

    async function handleAddNew(formData: ITipoRelacaoCliente) {
        if (formData.DS_TIPO_RELACAO_CLIENTE) {
            await InserirTipoRelacaoCliente({
                DS_TIPO_RELACAO_CLIENTE: formData.DS_TIPO_RELACAO_CLIENTE,
            });
            setIsAddCollapseOpen(false);
            updateListaTipoRelacaoCliente();
            reset({
                DS_TIPO_RELACAO_CLIENTE: "",
            });
        }
    }

    async function handleDelete(row: ITipoRelacaoCliente) {
        Swal.fire({
            title: "Tem certeza que deseja excluir esse tipo relação?",
            text: "Esta ação não poderá ser desfeita!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await ExcluirTipoRelacaoCliente(row.TIPO_RELACAO_CLIENTE);
                updateListaTipoRelacaoCliente();
                setIsAddCollapseOpen(false);
                setEditingRow(null);
                setIsCollapseOpen(false);
            }
        });
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_TIPO_RELACAO_CLIENTE",
            text: "Tipos de Relação Cliente",
        },
        {
            dataField: "actions",
            text: "Ações",
            isDummyField: true,
            formatter: (cell, row) => (
                <div className="d-flex">
                    <button
                        className="btn btn-outline-primary mx-1"
                        onClick={() => {
                            setEditingRow(row);
                            setIsCollapseOpen(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                        className="btn btn-outline-danger mx-1"
                        onClick={() => handleDelete(row)}
                        disabled={ExcluirTipoRelacaoClienteLoading}
                    >
                        {ExcluirTipoRelacaoClienteLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faTrash} />
                        )}
                    </button>
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="Row1 d-flex flex-columns row">
                <div className="col-12">
                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-success mb-1"
                            onClick={() => setIsAddCollapseOpen(true)}
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />
                            Novo
                        </button>
                    </div>
                    <Collapse in={isAddCollapseOpen} timeout={500}>
                        <FormProvider {...formMethods}>
                            <div className="col-12 mt-3">
                                <UnForm
                                    handleSubmit={handleAddNew}
                                    usingContext
                                >
                                    <div className="form-group">
                                        <UnForm.Input
                                            name="DS_TIPO_RELACAO_CLIENTE"
                                            label="Tipo de Relação"
                                            type="text"
                                        />
                                    </div>
                                    <div className="d-flex justify-content-end mb-1">
                                        <UnForm.SubmitButton
                                            wrapperClassName=""
                                            className="mr-1"
                                            color="primary"
                                            icon={faPlus}
                                            disabled={
                                                InserirTipoRelacaoClienteLoading
                                            }
                                            loading={
                                                InserirTipoRelacaoClienteLoading
                                            }
                                            loadingSize="sm"
                                        >
                                            Adicionar
                                        </UnForm.SubmitButton>
                                        <button
                                            className="btn btn-outline-danger"
                                            type="button"
                                            onClick={() =>
                                                setIsAddCollapseOpen(false)
                                            }
                                            disabled={
                                                InserirTipoRelacaoClienteLoading
                                            }
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </UnForm>
                            </div>
                        </FormProvider>
                    </Collapse>
                    <Table
                        keyField="TIPO_RELACAO_CLIENTE"
                        columns={columns}
                        data={lstTipoRelacaoCliente ?? []}
                        loading={lstTipoRelacaoClienteLoading}
                        bordered={false}
                    />
                </div>
            </div>
            <Collapse in={isCollapseOpen} timeout={500}>
                <div className="col-12 mt-3">
                    <UnForm handleSubmit={handleSaveEdit}>
                        <div className="form-group">
                            <UnForm.Input
                                name="DS_TIPO_RELACAO_CLIENTE"
                                label="Tipo de Relação"
                                type="text"
                                defaultValue={
                                    editingRow?.DS_TIPO_RELACAO_CLIENTE
                                }
                                placeholder="Digite a nova descrição"
                            />
                        </div>
                        <div className="d-flex justify-content-end">
                            <UnForm.SubmitButton
                                wrapperClassName=""
                                className="mr-1"
                                color="primary"
                                icon={faEdit}
                                disabled={AlterarTipoRelacaoClienteLoading}
                                loading={AlterarTipoRelacaoClienteLoading}
                                loadingSize="sm"
                            >
                                Salvar
                            </UnForm.SubmitButton>
                            <button
                                className="btn btn-outline-danger"
                                type="button"
                                onClick={() => {
                                    setEditingRow(null);
                                    setIsCollapseOpen(false);
                                }}
                                disabled={AlterarTipoRelacaoClienteLoading}
                            >
                                Cancelar
                            </button>
                        </div>
                    </UnForm>
                </div>
            </Collapse>
        </>
    );
}
